module.exports = __webpack_public_path__ + "static/media/covi_wel_sta_shi.ece4189a.png";